import { useMemo } from 'react';
import { useApp } from '@/contexts/AppContext';
import { buildReviewCommentsIndex, type ReviewCommentsIndex } from '@/lib/reviewCommentsIndex';

export function useReviewCommentsIndex(): ReviewCommentsIndex {
  const { reviewComments = [], diagrams = [], notes = [] } = useApp();
  return useMemo(
    () => buildReviewCommentsIndex({ reviewComments, diagrams, notes }),
    [reviewComments, diagrams, notes],
  );
}
